import {
  CONTRACT_SETUP_ALL_STATE_CLEAR,
  CONTRACT_SETUP_LABEL_IDS_CHANGE,
} from '@app/store/actionTypes';
import { ContractSetupAction } from '@app/store/contract-setup/actions';

type ContractSetupLabelIdsState = string[];

const initialState: ContractSetupLabelIdsState = [];

export default function reducer(
  state: ContractSetupLabelIdsState = initialState,
  action: ContractSetupAction
): ContractSetupLabelIdsState {
  switch (action.type) {
    case CONTRACT_SETUP_ALL_STATE_CLEAR:
      return initialState;
    case CONTRACT_SETUP_LABEL_IDS_CHANGE:
      return action.payload.labelIds;
    default:
      return state;
  }
}
